module.exports = __webpack_public_path__ + "img/banner-principal.42ea2ba1.svg";